import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const addProvider = createAsyncThunk(
  "worker/provider-register",
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/userregister`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const addWorkerApplicant = createAsyncThunk(
  "worker/worker-applicant",
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/applicantStore`,
        formData,
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const addPartner = createAsyncThunk(
  "worker/add-partner",
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/partnerStore`,
        formData,
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

const workerRegisterSlice = createSlice({
  name: "workerRegister",
  initialState: {
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProvider.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addProvider.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Worker Register successfully";
      })
      .addCase(addProvider.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(addWorkerApplicant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addWorkerApplicant.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Worker Applicant successfully";
      })
      .addCase(addWorkerApplicant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(addPartner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPartner.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Partner Register successfully";
      })
      .addCase(addPartner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
  },
});

export default workerRegisterSlice.reducer;